import Icon from '../components/Icon.vue'

Icon.register({
  'remove-format': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M336 416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-128c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h32.5l26.5-79.6 67.1 51.8-9.3 27.8h11.2zM633.8 458.1c3.4 2.7 6.2 8.3 6.2 12.6 0 3-1.5 7.4-3.4 9.8l-19.6 25.3c-2.7 3.4-8.3 6.2-12.6 6.2-3 0-7.4-1.5-9.8-3.4l-588.4-454.7c-3.4-2.7-6.2-8.3-6.2-12.6 0-3 1.5-7.4 3.4-9.8l19.6-25.3c2.7-3.4 8.3-6.2 12.6-6.2 3 0 7.4 1.5 9.8 3.4l114.5 88.5v-43.9c0-8.8 7.2-16 16-16h416c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-32h-117.8l-49.2 147.6zM309.9 207.8l31.9-95.8h-117.8v29.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/remove-format.js
// module id = 1835
// module chunks = 0